function translateGraphQLError(i18n, message) {
	if (message?.startsWith('VALIDATOR|')) {
		const validateSplit = message.split('|');
		const key = i18n.te(`errorMessages.validators.keys.${validateSplit[2]}`) ? i18n.t(`errorMessages.validators.keys.${validateSplit[2]}`) : validateSplit[2];
		const value = i18n.te(`errorMessages.validators.keys.${validateSplit[3]}`) ? i18n.t(`errorMessages.validators.keys.${validateSplit[3]}`) : validateSplit[3];
		return i18n.t(`errorMessages.validators.${validateSplit[1]}`, { key, value })
	} else if (message?.startsWith('NOT_FOUND|')) {
		const validateSplit = message.split('|');
		const key = i18n.te(`errorMessages.notFound.keys.${validateSplit[1]}`) ? i18n.t(`errorMessages.notFound.keys.${validateSplit[1]}`) : validateSplit[1];
		return i18n.t(`errorMessages.notFound.message`, { key })
	}
	return i18n.te(`errorMessages.${message}`) ? i18n.t(`errorMessages.${message}`) : message;
}

export function gqlErrorToast(toast, i18n, gqlError, except = [], notShowToast = false, isExceptPartial = false) {
	const excluded = {}
	const handledErrors = []
	let hasError = false
	const handleErrors = (errors) => {
		for (let i = 0; i < errors.length; i++) {
			const e = errors[i]
			const exceptFound = except.find(message => isExceptPartial ? e.message.includes(message) : message === e.message)
			if (exceptFound) {
				excluded[exceptFound] = e
			} else {
				hasError = true;
				let message = e.extensions?.exception?.constraint ?? e.extensions?.response?.message ?? e.message;
				if (Array.isArray(message) && message.length > 0) message = message[0];
				const handledError = translateGraphQLError(i18n, message)
				handledErrors.push(handledError)
				if (!notShowToast) toast.error(handledError)
			}
		}
	}
	
	if (gqlError.networkError) {
		if (gqlError.networkError.result) handleErrors(gqlError.networkError.result.errors)
		else handleErrors([gqlError.networkError])
	} else if (gqlError.graphQLErrors) {
		handleErrors(gqlError.graphQLErrors)
	} else {
		toast.error(gqlError.message)
	}
	
	return {
		excluded,
		hasError,
		handledErrors
	}
}
